import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/service/modal.service';
import { RequestService } from 'src/app/service/request.service';
import { WebhookService } from 'src/app/service/webhook.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  webhooks: any = {};
  total: number = 0;
  sending: number = 0;
  receiving: number = 0;
  fetchingData: boolean = false;
  requests: any = {};
  isModalOpen: boolean = false;
  individualRequest: any = {};
  webhookConfig: any = {};
  webhookId: string;
  modalTitle: string = 'Request details';
  data: any;
  searchRequest: string = '';
  fromDate: null | Date = null;
  toDate: null | Date = null;
  responseState: string = "";
  method: string = "";
  limit: number = 25;
  pageNum: number = 1;
  totalList: any;

  tableHeaders: string[] = [
    'Name',
    'Type',
    'Resend',
    'Resend Duration',
    'URL',
    'Status',
    'Trials',
    // 'Created At',
  ];
  tableData: any[] = [];

  constructor(
    private webhookService: WebhookService,
    private router: Router,
    private requestService: RequestService
  ) {
    const today = new Date();
    this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    this.toDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    this.data = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: null,
        toDate: null,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'type',
        label: 'Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'virtual', value: 'Virtual' },
          { key: 'physical', value: 'Physical' },
        ],
      },
      {
        type: 'select',
        name: 'brand',
        label: 'Brand',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'Verve', value: 'Verve' },
          { key: 'Visa', value: 'Visa' },
          { key: 'MasterCard', value: 'Mastercard' },
        ],
      },
      {
        type: 'select',
        name: 'currency',
        label: 'Currency',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'NGN', value: 'NGN' },
          { key: 'USD', value: 'USD' },
        ],
      },
    ];
  }

  ngOnInit() {
    this.getWebhooks();
    this.getRequests();
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  singleRequest = (id: string | number) => {
    this.individualRequest = this.requests.find(
      (obj: { _id: string | number }) => obj._id === id
    );
    // console.log(this.individualRequest);
    this.webhookConfig = this.individualRequest.webhookConfig;
    this.isModalOpen = true;
  };

  closeModal = () => {
    this.isModalOpen = false;
  };

  async getRequests() {
    this.fetchingData = true;
    this.requestService
      .getRequests(
        this.pageNum,
        this.limit,
        this.fromDate,
        this.toDate,
        this.responseState,
        this.method,
        this.searchRequest,
        this.webhookId
      )
      .subscribe({
        next: (res: any) => {
          this.requests = res.data.slice(0, 10);
          // console.log(this.requests);
          // console.log(this.info)
          if (this.requests.length > 0) {
            for (let i = 0; i < this.requests.length; i++) {}
            this.tableData = this.requests?.map((i: any, n: number) => {
              return [
                i._id,
                i.webhookConfig.name,
                i.webhookConfig.type,
                i.webhookConfig.resend,
                i.webhookConfig.resendDuration,
                i.url,
                i.responseStatus,
                i.trials,
                // i.createdAt,
              ];
            });
          }
          this.fetchingData = false;
          error: (error: any) => {
            // this.fetchingData = false;
          };
        },
      });
  }

  onFilterChanged(value: any) {
    // console.log(value);
    this.fromDate = value[0].fromDateValue;
    this.toDate = value[0].toDateValue;
    // console.log(this.fromDate);
    // console.log(this.fromDate);
    this.getRequests();
  }

  async getWebhooks() {
    // this.fetchingData = true;
    (await this.webhookService.getWebhooks()).subscribe({
      next: (res: any) => {
        this.webhooks = res.data;
        // console.log(this.webhooks);
        this.total = this.webhooks.length;
        const totalSending = this.webhooks.filter(
          (obj: { type: string }) => obj.type === 'Sending'
        );
        this.sending = totalSending.length;
        const totalReceiving = this.webhooks.filter(
          (obj: { type: string }) => obj.type === 'Receiving'
        );
        this.receiving = totalReceiving.length;

        error: (error: any) => {
          // this.fetchingData = false;
        };
      },
    });
  }
}
